/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {};

/**
 * Slice
 */
export const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    resetAppConfigState: (state) => {
      state = initialState;
      return state;
    },

    setAppConfigData: (state, action) => {
      state = {
        ...action.payload,
        phoneMask: action.payload.phoneMask.replace(/_/g, '0'),
      };

      return state;
    },
  },
});

/**
 * Thunks
 */

export const { resetAppConfigState, setAppConfigData } = appConfigSlice.actions;

export const fetchAppConfig = () => async (dispatch) => {
  const { data } = await axios.get('/public/AppConfig/');

  return dispatch(setAppConfigData(data));
};

/**
 * Selectors
 */
export const selectCaptchaKey = (state) => state.appConfig.captchaSiteKey;
export const selectPhoneMask = (state) => state.appConfig.phoneMask;
export const selectAppConfig = (state) => state.appConfig;

export default appConfigSlice.reducer;
